import { ThunkMiddleware } from 'redux-thunk';
import { getCurrentEnterpriseId, getCurrentProfileIdOrNull } from '@mews-commander/core';
import { TrackingConsent } from '@mews/enums';
import { createHandler } from '@mews/std';
import { JSON_DOWNLOAD_STARTED } from '../modules/enterpriseBuilder/actions/types';

const EVENT_TRACKED = '@@analytics/event';
const PAGE_VIEW_TRACKED = '@@analytics/pageView';

export const trackEvent = ({ eventCategory, eventAction, eventLabel, eventValue, options = {} }: $TSFixMe) => ({
    type: EVENT_TRACKED,
    payload: { eventCategory, eventAction, eventLabel, eventValue, options },
});

export const trackPageView = ({ url }: $TSFixMe) => ({
    type: PAGE_VIEW_TRACKED,
    payload: { url },
});

export const dispatchWithEventTracking =
    (eventTrackingObject: $TSFixMe) =>
    (...trackedActions: $TSFixMe[]) =>
    (dispatch: $TSFixMe) => {
        trackedActions.forEach(dispatch);
        dispatch(trackEvent(eventTrackingObject));
    };

export default ({ loggerService, trackingConsentsService, appClockService }: $TSFixMe): ThunkMiddleware =>
    () => {
        const trackEventWithData = prepareEventTracking({ loggerService, appClockService });

        const eventMap = {
            [EVENT_TRACKED]: (data: $TSFixMe) => trackEventWithData(data),
            [PAGE_VIEW_TRACKED]: preparePageViewTracking({ loggerService, appClockService }),
            [JSON_DOWNLOAD_STARTED]: () =>
                trackEventWithData({
                    eventCategory: 'PropertyBuilder',
                    eventAction: 'link clicked',
                    eventLabel: 'download JSON',
                }),
        };

        const eventHandler = createHandler(eventMap, () => {});

        return (next) => (action) => {
            const isConsentGiven = trackingConsentsService.isConsentGiven(TrackingConsent.Functional);
            if (isConsentGiven) {
                eventHandler(action.type, action.payload);
            }

            next(action);
        };
    };

const getCustomDimensions = () => ({
    enterpriseId: getCurrentEnterpriseId(),
    profileId: getCurrentProfileIdOrNull(),
});

const preparePageViewTracking =
    ({ loggerService, appClockService }: $TSFixMe) =>
    ({ url = '' }) => {
        const customDimensions = getCustomDimensions();

        loggerService.log('event', 'Analytics PageView', {
            timestamp: appClockService.getAppNowUtc().value,
            page: url.toLowerCase(),
            ...customDimensions,
        });
    };

const prepareEventTracking =
    ({ loggerService, appClockService }: $TSFixMe) =>
    ({ eventCategory, eventAction, eventLabel, eventValue, options = {} }: $TSFixMe) => {
        const customDimensions = getCustomDimensions();

        const eventData = {
            eventCategory,
            eventAction,
            eventLabel,
            eventValue,
            ...options,
        };

        loggerService.log('event', 'Analytics Event', {
            timestamp: appClockService.getAppNowUtc().value,
            ...eventData,
            ...customDimensions,
        });
    };
